import type { FleetGeometry } from "../lib/geometry";


interface FuselageProps {
  geometry: FleetGeometry;
}


export default function Fuselage({ geometry }: FuselageProps) {
  const {
    fuselageLeft, fuselageRight,
    seatGridYStart, seatGridHeight,
  } = geometry;

  const midX  = (fuselageLeft + fuselageRight) / 2;
  const halfW = (fuselageRight - fuselageLeft) / 2;
  const bodyTop    = seatGridYStart - 4;
  const bodyBottom = seatGridYStart + seatGridHeight + 4;
  const noseTip    = bodyTop - 50;
  const tailTip    = bodyBottom + 75;

  const d = [
    `M ${midX},${noseTip}`,
    `C ${midX - halfW * 0.62},${noseTip} ${fuselageLeft},${bodyTop - 18} ${fuselageLeft},${bodyTop + 10}`,
    `L ${fuselageLeft},${bodyBottom - 10}`,
    `C ${fuselageLeft},${bodyBottom + 30} ${midX - halfW * 0.55},${tailTip} ${midX},${tailTip}`,
    `C ${midX + halfW * 0.55},${tailTip} ${fuselageRight},${bodyBottom + 30} ${fuselageRight},${bodyBottom - 10}`,
    `L ${fuselageRight},${bodyTop + 10}`,
    `C ${fuselageRight},${bodyTop - 18} ${midX + halfW * 0.62},${noseTip} ${midX},${noseTip}`,
    "Z",
  ].join(" ");

  return (
    <path
      d={d}
      fill="rgba(15,23,42,0.015)"
      stroke="rgba(15,23,42,0.18)"
      strokeWidth={1.2}
      pointerEvents="none"
    />
  );
}
